import React, { FC } from 'react'
import { useHistory } from 'react-router'

import {
  useFlag,
  useGetNewNotificationsCount,
  routes,
} from '@sketch/modules-common'

// Icons
import { icons } from './icons'

// Components
import { Dropdown, SelectDropdownLinkItem } from '@sketch/components'
import UserNavbarSection from 'modules/user/components/UserNavbarSection'

// Local Components
import HelpMenu from './components/HelpMenu'

// Styles
import {
  NoWorkspacesAvatar,
  NoWorkspacesDropdown,
  NoWorkspacesIcon,
  NoWorkspacesTitle,
} from './NoWorkspaceSidebar.styles'

import {
  SidebarWrapper,
  MenuWrapper,
  StyledPill,
  WorkspaceSelectorWrapper,
  FooterWrapper,
} from './Sidebar.styles'

// Types
import { useGetInitialUserQuery } from '@sketch/gql-types'

// Helpers
import { menuItemsText } from './menuItems'
import BottomMenu from './components/BottomMenu/BottomMenu'

export const NoWorkspaceSidebar: FC = () => {
  const history = useHistory()

  /**
   * Sidebar FF clean up
   * https://github.com/sketch-hq/Cloud/issues/15634
   */
  const isSidebarFFOn = useFlag('sidebar')

  const { data: userData } = useGetInitialUserQuery()

  const newNotificationsCount = useGetNewNotificationsCount()
  const hasNewNotifications = newNotificationsCount > 0

  const isPartner = userData?.me.isPartner

  return (
    <SidebarWrapper>
      <WorkspaceSelectorWrapper>
        <NoWorkspacesDropdown
          isPartner={isPartner}
          onClick={() => {
            if (!isPartner) {
              history.push(routes.WORKSPACE_CREATE.create({}))
            }
          }}
        >
          <NoWorkspacesAvatar />
          <NoWorkspacesTitle>No Workspaces</NoWorkspacesTitle>
          <NoWorkspacesIcon>
            <Dropdown.Chevrons />
          </NoWorkspacesIcon>
        </NoWorkspacesDropdown>
      </WorkspaceSelectorWrapper>
      <MenuWrapper>
        <SelectDropdownLinkItem
          icon={icons.BellIcon}
          text={menuItemsText.updates}
          to={routes.UPDATES.create({})}
          additional={
            hasNewNotifications && (
              <StyledPill variant="secondary">New</StyledPill>
            )
          }
        />
        <HelpMenu />
      </MenuWrapper>
      <FooterWrapper>
        {isSidebarFFOn && <BottomMenu />}
        <UserNavbarSection />
      </FooterWrapper>
    </SidebarWrapper>
  )
}
